import { IconButton, Menu, MenuItem, Tooltip, Typography } from "@mui/material";
import { FC, useState } from "react";

interface MenuItemProps {
    label: string;
    onClick?: () => void;
}

interface IconMenuWithTooltipProps {
    icon: React.ReactNode;
    menuItems: MenuItemProps[];
    anchorProps?: {
        placement?: "top" | "bottom" | "left" | "right";
    };
}

const IconMenuWithTooltip: FC<IconMenuWithTooltipProps> = ({ icon, menuItems, anchorProps }) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            <IconButton
                aria-label="menu"
                aria-controls="menu"
                aria-haspopup="true"
                onClick={handleOpen}
                sx={{"svg":{fontSize: '25px !important'}}}
            >
                {icon}
            </IconButton>
            <Menu
                id="menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                {menuItems.map((item, index) => (
                    <MenuItem key={index} onClick={() => { 
                        item.onClick?.();
                        handleClose();
                    }}>
                        <Typography variant="subtitle1" gutterBottom>
                            {item.label}
                        </Typography>
                    </MenuItem>
                ))}
            </Menu>
        </div>
    );
};

export default IconMenuWithTooltip;